import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import PanelRealCases from "@/pages/PanelRealCases";

export const Route = createFileRoute("/panel/casos")({
  head: () => ({
    meta: [
      { title: "Casos Reales de comercios y bares | Retail Lemon" },
      {
        name: "description",
        content:
          "Vídeos breves de comerciantes y hosteleros contando su mayor reto y cómo lo resolvieron en su local.",
      },
      { property: "og:title", content: "Casos Reales de comercios y bares | Retail Lemon" },
      {
        property: "og:description",
        content: "Comerciantes reales cuentan en 30 segundos su reto y la solución que aplicaron.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: () => (
    <ProtectedRoute>
      <PanelRealCases />
    </ProtectedRoute>
  ),
});
